import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@edil/ui/styles.css';
import './fonts.css';
import { App } from './App';
import { AppProvider } from '@/components/app-provider';
import { ServiceWorker } from '@/components/service-worker';
import { RouterProvider } from '@/router';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider>
      <AppProvider>
        <App />
      </AppProvider>
      <ServiceWorker />
    </RouterProvider>
  </StrictMode>,
);
